<layout-sidebar>
  <div class="replace-vehicle grace-period main">
    @if (showErrorMessage) {
      <div class="row margin-bottom-20">
        <div class="column twelve">
          <div class="high-alert alert">
            <div class="items-center flex">
              <span class="icon-alert"></span>
              <div class="alert-message">
                Unfortunately, we were unable to contact your agent. Please try again later, or
                contact your agent directly to arrange coverage for your new vehicle.
              </div>
            </div>
            @if (selectedAgent) {
              <div class="pad-top-10 pad-left-40">
                {{ selectedAgent.firstName }} {{ selectedAgent.middleName }}
                {{ selectedAgent.lastName }}
              </div>
            }
            @if (selectedAgent) {
              <div class="row pad-top-10 pad-left-40">
                <div class="column six">
                  <ul>
                    @for (phone of selectedAgent?.phones; track phone) {
                      <li>
                        <a
                          [href]="getPhoneNumber(phone.areaCode + phone.phoneNumber)"
                          target="_blank"
                          >{{ phone.areaCode + phone.phoneNumber | prettyPhoneNumber }}</a
                        >
                      </li>
                    }
                  </ul>
                </div>
                <div class="column six">
                  <ul>
                    @for (email of selectedAgent?.emails; track email) {
                      <li>
                        <a [href]="getAgentURL()" target="_blank">{{ email }}</a>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }

    <form [formGroup]="agentNotificationForm" (ngSubmit)="submit()">
      <div class="row">
        @if (!(autoWhatIfError | async)) {
          <div class="column twelve">
            <span data-cy="gracePeriodSubheading" class="heading-sub-page"
              >Looking to add or replace a vehicle?</span
            >
          </div>
        }
        @if (autoWhatIfError | async) {
          <div class="column twelve" data-cy="replaceVehicleErrorMsg">
            <div class="heading-sub-page row" dsContent [contentPath]="'policy.PGPOOPs'"></div>
            <div class="heading-sub-page row" dsContent [contentPath]="'policy.PGPNeverFear'"></div>
            <div
              class="heading-sub-page row"
              dsContent
              [contentPath]="'policy.PGPDidYouKnow'"
            ></div>
          </div>
        }
      </div>
      <div class="row pad-top-10">
        <div class="column twelve">
          <div class="row pad-bottom-20">
            <div
              dsContent
              [contentPath]="'policy.gracePeriodPageContent'"
              [options]="{
                gracePeriodDays: gracePeriodDays$ | async,
                regularGracePeriodDays: regularGracePeriodDays,
                descriptionType: descriptionType
              }"
              class="column twelve"
            ></div>
            @if ((isPartner$ | async) === false) {
              <div
                dsContent
                [contentPath]="'policy.gracePeriodAlreadyBoughtTheCar'"
                class="pad-top-10 column twelve"
              ></div>
            }
          </div>
          <div class="row">
            @if (producers?.length >= 1) {
              <div class="column twelve">
                <ds-form-control-container
                  [ngClass]="{ none: producers?.length === 1 }"
                  [labelText]="'Select which agent'"
                  [control]="agentNotificationForm.get('selectAgent')"
                >
                  <select id="selectAgent" class="icon fill" formControlName="selectAgent">
                    <option value=""></option>
                    @for (producer of producers; track producer) {
                      <option [value]="producer.id">
                        {{ producer.firstName }} {{ producer.middleName }} {{ producer.lastName }}
                      </option>
                    }
                  </select>
                  <span class="icon-chevron-down"></span>
                  <ds-form-control-message
                    [control]="agentNotificationForm.get('selectAgent')"
                  ></ds-form-control-message>
                </ds-form-control-container>
              </div>
            }
            <div class="column twelve flex items-center pad-top-20">
              @if (selectedAgent || producers?.length > 0) {
                <button
                  ds-button
                  data-cy="gracePeriodNotifyAgentButton"
                  class="margin-right-20"
                  [disabled]="
                    !(agentNotificationForm.valid || selectedAgent || producers?.length === 1) ||
                    !(roleService.isAuthorized('notifyagent_pgp') | async)
                  "
                  type="submit"
                >
                  {{ (isPartner | async) ? 'Notify Agent' : 'Send To My Agent' }}
                </button>
              }
              @if (isPartner$ | async) {
                <a
                  href="javascript:void(0)"
                  [dsRouterLink]="['/policies']"
                  data-cy="gracePeriodBackLink"
                  >Back to Policies</a
                >
              }
              @if ((isPartner$ | async) === false && showOverviewLink) {
                <a
                  href="javascript:void(0)"
                  [dsRouterLink]="['/overview']"
                  data-cy="gracePeriodBackLink"
                  >Back to Overview</a
                >
              }
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <aside class="main-aside"><links-agents-sidebar></links-agents-sidebar></aside>
</layout-sidebar>
